export default __webpack_public_path__ + "static/media/saxophonretreat-element.c2a2b159.jpg";